import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/DataList/data-list';
export var DataListCell = function DataListCell(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$width = _a.width,
      width = _a$width === void 0 ? 1 : _a$width,
      _a$isFilled = _a.isFilled,
      isFilled = _a$isFilled === void 0 ? true : _a$isFilled,
      _a$alignRight = _a.alignRight,
      alignRight = _a$alignRight === void 0 ? false : _a$alignRight,
      _a$isIcon = _a.isIcon,
      isIcon = _a$isIcon === void 0 ? false : _a$isIcon,
      props = __rest(_a, ["children", "className", "width", "isFilled", "alignRight", "isIcon"]);

  return React.createElement("div", Object.assign({
    className: css(styles.dataListCell, width > 1 && styles.modifiers["flex_".concat(width)], !isFilled && styles.modifiers.noFill, alignRight && styles.modifiers.alignRight, isIcon && styles.modifiers.icon, className)
  }, props), children);
};